import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  NotificationReport,
  Export,
} from '@/domain/entities/NotificationReports'
import router from '@/router'
import Vue from 'vue'
import { NotificationReportReportPresenter } from '@/app/ui/presenters/NotificationReportPresenter'
import { AuthModule } from './auth'

export interface NotificationReportsState {
  NotificationReportData: NotificationReport
  exportData: Export
  isLoading: boolean
  paginationParam: Object
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'NotificationReport',
})
class NotificationReports extends VuexModule
  implements NotificationReportsState {
  public isLoading = true
  public isLoadingExport = true
  public NotificationReportData = new NotificationReport(true, '')
  public exportData = new Export(true, '')
  public paginationParam = {
    filter: {
      Title: '',
      MaterialType: '',
      start: '',
      end: '',
      createstart: '',
      createend: '',
    },
  }
  public paginationParamsExport = {
    filter: {
      dealer: '',
      city: '',
      branch: '',
      start: '',
      end: '',
    },
  }

  @Action
  public async getNotificationReport() {
    this.setLoading(true)
    // console.log('Data masuk ke module')
    const presenter = await container.resolve(NotificationReportReportPresenter)
    presenter
      .loadNotificationReportReport(this.paginationParam)
      .then((res: NotificationReport) => {
        this.setLoading(false)
        this.setNotificationData(res)
        // console.log('Notification Data', res)
      })
      .catch((error) => {
        console.error('error', error)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        this.setLoading(false)
      })
  }
  // @Action
  // public async getExportData() {
  //   this.setLoading(true)
  //   const presenter = await container.resolve(NotificationRerportReportPresenter)
  //   presenter
  //     .loadExport(this.paginationParam)
  //     .then((res: Export) => {
  //       this.setExportData(res)
  //       //  console.log('export dataaa', res)
  //     })
  //     .catch((error) => {
  //       console.error('error', error)
  //     })
  //     .finally(() => {
  //       this.setLoadingExport(false)
  //     })
  // }

  @Mutation
  private setNotificationData(notificationReport: NotificationReport) {
    this.NotificationReportData = notificationReport
  }
  // @Mutation
  // private setExportData(exp: Export) {
  //   this.exportData = exp
  // }
  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  // @Mutation
  // private setLoadingExport(isLoadingExport: boolean) {
  //   this.isLoadingExport = isLoadingExport
  // }
}

export const NotificationReportModule = getModule(NotificationReports)
